import firebase from "firebase/app";
import "firebase/auth";
import "firebase/database";

//this config is being used for both development and production environment. Though, it is a best practice creating a second project and have two configs: one for production (prodConfig) and another for development (devConfig), so you choose the config based on the environment.

const config = {
  apiKey: "AIzaSyArWsqBMM-9jrMmw59xsGXuP6CTsb6ha_s",
  authDomain: "jharkart-3f408.firebaseapp.com",
  databaseURL: "https://jharkart-3f408.firebaseio.com",
  projectId: "jharkart-3f408",
  storageBucket: "jharkart-3f408.appspot.com",
  messagingSenderId: "243785276661",
  appId: "1:243785276661:web:5d1fcfa0069d6795ea39bc",
  measurementId: "G-4WLME0KZK2"
};

if (!firebase.apps.length) {
  //initializing with the config object
  firebase.initializeApp(config);
}

//separting database API and authentication
const db = firebase.database();
const auth = firebase.auth();

const facebookProvider = new firebase.auth.FacebookAuthProvider();

export { db, auth, facebookProvider };
